// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * Code editor services token.
 */
export const IEditorServices = new Token('@jupyterlab/codeeditor:IEditorServices');
//# sourceMappingURL=tokens.js.map